/* ============================================================
   Gift-box capacity check — Sleek theme (FoxEcom), no app.
   Notes:
     - Both wrap variants (Standard Box + Premium Box) are capacity boxes.
     - Box price is read live from the cart line, so it always matches (e.g. Rs 250).
     - Bridal uses the same 12-unit model; detection via bridalProductIds from Liquid.
     - Styling matches thetowelcompany.co: Roboto / Roboto Slab, brand palette.
     - Verify in the browser console with: gbxDebug()
   ============================================================ */
(function () {
  const CFG = Object.assign({
    typeUnits:  { set:12, bath:6, hand:3, guest:2, face:1 },  // face = 1 unit; box holds 12
    typeLabels: { set:'Complete Set', bath:'Bath Towel', hand:'Hand Towel', guest:'Guest Towel', face:'Face Towel' },
    fillOrder:  ['set','bath','hand','guest','face'],         // overflow fills largest-first
    matchers: [ ['set','complete set|4[- ]?piece'], ['bath','bath'], ['hand','hand'], ['guest','guest'], ['face','face'] ],

    // --- Wrapping channels: every box variant carries the 12-unit capacity ---
    channels: [
      { name:'regular',
        boxVariantIds:  [48409398345973, 48409398378741],  // Standard Box + Premium Box
        wrapVariantIds: [],
        appliesTo:'non-bridal', boxCapacity:12 },
      { name:'bridal',
        boxVariantIds:  [48409399034101, 48409399066869],  // Standard + Premium bridal boxes
        wrapVariantIds: [],
        appliesTo:'bridal',     boxCapacity:12 }
    ],

    // --- Bridal detection (choose one; Liquid injects bridalProductIds) ---
    bridalProductTypes: [],
    bridalProductIds:   [],

    checkoutSelectors: ['[name="checkout"]','.cart__checkout','.cart__checkout-button','a[href="/checkout"]','a[href^="/checkout"]']
  }, window.GBX_CONFIG || {});

  const rx = CFG.matchers.map(([k, src]) => [k, new RegExp(src)]);
  const allWrapIds = new Set(CFG.channels.flatMap(c => [...c.boxVariantIds, ...c.wrapVariantIds]).map(Number));
  const bridalIds  = new Set((CFG.bridalProductIds || []).map(Number));
  const bridalTypes = (CFG.bridalProductTypes || []).map(s => s.toLowerCase());

  const isBridal = it =>
    bridalTypes.includes((it.product_type || '').toLowerCase()) || bridalIds.has(Number(it.product_id));

  function classifyType(item) {
    if (allWrapIds.has(Number(item.variant_id))) return null;  // never count a wrap line as a towel
    const hay = [item.variant_title, ...((item.options_with_values||[]).map(o=>o.value)),
                 item.product_title || item.title, item.handle].join(' ').toLowerCase();
    for (const [k, re] of rx) if (re.test(hay)) return k;
    return null;
  }

  const getCart = () => fetch('/cart.js', { headers:{Accept:'application/json'} }).then(r=>r.json());

  function evaluate(cart) {
    return CFG.channels.map(ch => {
      const boxIds = ch.boxVariantIds.map(Number);
      let boxQty = 0; const boxLines = [], counts = {set:0,bath:0,hand:0,guest:0,face:0};
      cart.items.forEach(it => {
        if (boxIds.includes(Number(it.variant_id))) { boxQty += it.quantity; boxLines.push(it); return; }
        const belongs = ch.appliesTo === 'bridal' ? isBridal(it) : !isBridal(it);
        if (!belongs) return;
        const t = classifyType(it);
        if (t) counts[t] += it.quantity;
      });
      const units = Object.keys(counts).reduce((s,k)=>s + counts[k]*CFG.typeUnits[k], 0);
      const boxesNeeded = Math.ceil(units / ch.boxCapacity) || 0;
      const boxUnitPrice = boxLines.length ? (boxLines[0].final_price || boxLines[0].price || 0)/100 : 0;
      return { ch, boxQty, boxLines, counts, units, boxesNeeded, boxUnitPrice,
               overflow: boxQty > 0 && boxesNeeded > boxQty };
    });
  }

  function packing(counts, boxQty, capacity) {
    let cap = boxQty * capacity; const fit = {}, over = {};
    CFG.fillOrder.forEach(k => {
      const u = CFG.typeUnits[k]; let n = counts[k], f = 0;
      while (n > 0 && cap >= u) { cap -= u; f++; n--; }
      fit[k] = f; over[k] = counts[k] - f;
    });
    return { fit, over };
  }

  /* ---------- UI ---------- */
  let built = false;
  function build() {
    if (built) return; built = true;
    const css = `
    .gbx-overlay{position:fixed;inset:0;background:rgba(0,42,58,.45);backdrop-filter:blur(2px);
      display:none;align-items:center;justify-content:center;padding:20px;z-index:9999}
    .gbx-overlay.gbx-show{display:flex}
    .gbx-modal{background:#fff;border-radius:16px;box-shadow:0 24px 60px -20px rgba(0,42,58,.38);
      width:100%;max-width:520px;overflow:hidden;
      font-family:'Roboto',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
      color:#002A3A;font-size:15px;line-height:1.5;
      animation:gbxpop .28s cubic-bezier(.2,.9,.3,1.1)}
    @keyframes gbxpop{from{opacity:0;transform:translateY(10px) scale(.98)}to{opacity:1;transform:none}}
    @media (prefers-reduced-motion:reduce){.gbx-modal{animation:none}}
    .gbx-head{padding:24px 26px 16px;display:flex;gap:14px;align-items:flex-start}
    .gbx-ic{flex:0 0 auto;width:42px;height:42px;border-radius:10px;background:#E5D9CD;display:grid;place-items:center}
    .gbx-head h2{margin:0;font-family:'Roboto Slab',Georgia,serif;font-weight:600;font-size:20px;letter-spacing:-.01em;color:#002A3A}
    .gbx-head p{margin:5px 0 0;color:rgba(0,42,58,.62);font-size:14.5px}
    .gbx-meter{padding:2px 26px 8px}
    .gbx-track{height:12px;border-radius:7px;background:#F3EEE6;display:flex;overflow:hidden}
    .gbx-seg{height:100%}
    .gbx-fit{background:#406E77}
    .gbx-over{background:#D5B696}
    .gbx-split{display:grid;grid-template-columns:1fr 1fr;padding:16px 26px 6px}
    .gbx-col h3{font-family:'Roboto Slab',Georgia,serif;font-weight:600;font-size:12.5px;letter-spacing:.04em;
      margin:0 0 9px;display:flex;align-items:center;gap:7px;color:#002A3A}
    .gbx-sw{width:9px;height:9px;border-radius:2px;flex:0 0 auto}
    .gbx-sw--fit{background:#406E77}.gbx-sw--over{background:#D5B696}
    .gbx-col ul{margin:0;padding:0;list-style:none;display:grid;gap:6px}
    .gbx-col li{font-size:14.5px;color:#002A3A}
    .gbx-col--fit{padding-right:18px}.gbx-col--over{border-left:1px solid #ECE6DB;padding-left:18px}
    .gbx-empty{font-size:14px;color:rgba(0,42,58,.5);font-style:italic}
    .gbx-actions{padding:18px 26px 24px;display:grid;gap:10px}
    .gbx-btn{border:0;border-radius:10px;padding:14px 18px;font-size:15px;font-weight:600;cursor:pointer;font-family:inherit;width:100%}
    .gbx-primary{background:#406E77;color:#fff;display:flex;justify-content:space-between;align-items:center}
    .gbx-primary:hover{background:#33585F}
    .gbx-ghost{background:#fff;color:#002A3A;border:1px solid rgba(0,42,58,.22)}
    .gbx-ghost:hover{background:#F7F2EA}
    .gbx-fine{font-size:12px;color:rgba(0,42,58,.55);text-align:center;margin:3px 0 0}
    @media (max-width:520px){.gbx-split{grid-template-columns:1fr;gap:16px}
      .gbx-col--over{border-left:0;padding-left:0;border-top:1px solid #ECE6DB;padding-top:14px}.gbx-col--fit{padding-right:0}}`;
    const s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);
    const el = document.createElement('div'); el.className = 'gbx-overlay'; el.id = 'gbx-overlay';
    el.innerHTML = `<div class="gbx-modal" role="dialog" aria-modal="true" aria-labelledby="gbx-title">
      <div class="gbx-head"><div class="gbx-ic" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#406E77" stroke-width="1.7">
        <path d="M3 8l9-4 9 4-9 4-9-4z"/><path d="M3 8v8l9 4 9-4V8"/><path d="M12 12v8"/></svg></div>
        <div><h2 id="gbx-title">Your gift box is full</h2><p id="gbx-sub"></p></div></div>
      <div class="gbx-meter"><div class="gbx-track"><div class="gbx-seg gbx-fit" id="gbx-segfit"></div>
        <div class="gbx-seg gbx-over" id="gbx-segover"></div></div></div>
      <div class="gbx-split">
        <div class="gbx-col gbx-col--fit"><h3><span class="gbx-sw gbx-sw--fit"></span>In your gift box</h3><ul id="gbx-fit"></ul></div>
        <div class="gbx-col gbx-col--over"><h3><span class="gbx-sw gbx-sw--over"></span>Standard packaging</h3><ul id="gbx-over"></ul></div></div>
      <div class="gbx-actions">
        <button class="gbx-btn gbx-primary" id="gbx-add"><span id="gbx-addl"></span><b id="gbx-addp"></b></button>
        <button class="gbx-btn gbx-ghost" id="gbx-cont">Keep it as is — rest ships standard</button>
        <p class="gbx-fine">You can change this anytime in your cart.</p></div></div>`;
    document.body.appendChild(el);
    el.addEventListener('click', e => { if (e.target === el) el.classList.remove('gbx-show'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') el.classList.remove('gbx-show'); });
  }

  function show(states, sig) {
    build();
    const $ = id => document.getElementById(id);
    states = states.slice().sort((a,b) =>
      (b.units - b.boxQty*b.ch.boxCapacity) - (a.units - a.boxQty*a.ch.boxCapacity));
    const p = states[0], have = p.boxQty, cap = have*p.ch.boxCapacity, u = p.units;
    const { fit, over } = packing(p.counts, have, p.ch.boxCapacity);
    const fitU = Math.min(u, cap), overU = Math.max(0, u - cap), denom = Math.max(u, cap) || 1;

    let sub = `The ${p.ch.name==='bridal'?'bridal ':''}towels in your cart need ${p.boxesNeeded} gift boxes to wrap fully — you've added ${have}.`;
    if (states.length > 1) sub += ` Your ${states[1].ch.name} items need another box too.`;
    $('gbx-sub').textContent = sub;

    $('gbx-segfit').style.width  = (fitU / denom * 100) + '%';
    $('gbx-segover').style.width = (overU / denom * 100) + '%';

    const line = (k, n) => `<li>${n}× ${CFG.typeLabels[k]}</li>`;
    const fh = CFG.fillOrder.filter(k=>fit[k]>0).map(k=>line(k,fit[k])).join('');
    const oh = CFG.fillOrder.filter(k=>over[k]>0).map(k=>line(k,over[k])).join('');
    $('gbx-fit').innerHTML  = fh || '<li class="gbx-empty">Nothing yet</li>';
    $('gbx-over').innerHTML = oh || '<li class="gbx-empty">Everything fits</li>';

    const extra = states.reduce((s,st)=> s + (st.boxesNeeded - st.boxQty), 0);
    const cost  = states.reduce((s,st)=> s + (st.boxesNeeded - st.boxQty)*st.boxUnitPrice, 0);
    $('gbx-addl').textContent = `Add ${extra} more gift box${extra>1?'es':''}`;
    $('gbx-addp').textContent = cost > 0 ? `+ Rs. ${cost.toLocaleString()}` : '';

    $('gbx-add').onclick = async () => {
      try {
        const updates = {};
        states.forEach(st => st.boxLines.forEach((l,i)=> updates[l.key] = i===0 ? st.boxesNeeded : 0));
        await fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ updates }) });
      } finally { window.location = '/checkout'; }
    };
    $('gbx-cont').onclick = () => { sessionStorage.setItem('gbx_ack', sig); window.location = '/checkout'; };
    $('gbx-overlay').classList.add('gbx-show');
    $('gbx-add').focus();
  }

  const proceed = btn => { window.location = (btn.tagName === 'A' && btn.href) ? btn.href : '/checkout'; };

  /* ---------- Trigger: intercept checkout ---------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(CFG.checkoutSelectors.join(','));
    if (!btn || btn.closest('.gbx-modal')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    (async () => {
      try {
        const overflowing = evaluate(await getCart()).filter(s => s.overflow);
        const sig = overflowing.map(s => `${s.ch.name}:${s.boxesNeeded}/${s.boxQty}`).join('|');
        if (overflowing.length && sessionStorage.getItem('gbx_ack') !== sig) { show(overflowing, sig); return; }
      } catch (err) { /* fail open */ }
      proceed(btn);
    })();
  }, true);

  /* ---------- Console helper: run gbxDebug() on the store ---------- */
  window.gbxDebug = async () => {
    const states = evaluate(await getCart());
    console.table(states.map(s => ({
      channel:s.ch.name, boxesInCart:s.boxQty, towelUnits:s.units,
      boxesNeeded:s.boxesNeeded, boxPrice:s.boxUnitPrice, overflow:s.overflow
    })));
    return states;
  };
})();